import type { ActionFormationDTO, FormationDTO, LovAfDTO } from '@/features/api/extranet/dto/Demande/AF'
import { buildDemandeService } from '../buildDemandeService'
import { idccAutoriseTT } from '@/features/domaine/regles-akto/shared'
import { EndPointsFormationDemandeAf } from '@/features/services'

export default buildDemandeService<'MODEL_AF', LovAfDTO>({
  location: EndPointsFormationDemandeAf.location,
  normaliserData: normaliserData,
})

function normaliserData(data: ActionFormationDTO) {
  //data.typeDemande ??= TypeDemandeDossier
  data.fichiers ??= []

  data.employeur ??= {} as any
  data.employeur!.contact ??= {} as any
  data.employeur!.etablissement ??= {} as any
  data.employeur!.etablissement!.adresse ??= {} as any

  data.salaries ??= []

  data.formation = data.formation ?? ({} as FormationDTO)
  data.formation!.modules ??= [] as any

  const estTT = idccAutoriseTT.includes(data?.employeur?.etablissement?.idcc?.code ?? '')
  if (estTT) {
    data.financement ??= {}
  }

  return data
}
